import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

import Home from './views/Home.vue'
import Extension from './views/Extension.vue'
import Order from './views/Order.vue'
import User from './views/User.vue'
import creditCard from './views/creditCard.vue'
import bankList from './views/bankList.vue'
import bankCard from './views/bankCard.vue'
import cardDetail from './views/cardDetail.vue'
import cardList from './views/cardList.vue'
import About from './views/About.vue'
import userInfo from './views/userInfo.vue'
Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/index'
        }, {
            path: '/index',
            component: Home,
            meta: {
                deep: 1,
                tool: true,
                title: '首页'
            }
        }, {
            path: '/extension',
            component: Extension,
            meta: {
                deep: 1,
                tool: true,
                title: '推广'
            }
        }, {
            path: '/order',
            component: Order,
            meta: {
                deep: 1,
                tool: true,
                title: '订单'
            }
        }, {
            path: '/user',
            component: User,
            meta: {
                deep: 1,
                tool: true,
                title: '用户中心'
            }
        }, {
            path: '/card/credit',
            component: creditCard,
            meta: {
                deep: 2,
                title: '信用卡'
            }
        }, {
            path: '/bank/list',
            component: bankList,
            meta: {
                deep: 3,
                title: '银行列表'
            }
        }, {
            path: '/bank/card',
            component: bankCard,
            meta: {
                deep: 4,
                title: '列表'
            }
        }, {
            path: '/card/detail',
            component: cardDetail,
            meta: {
                deep: 5,
                title: '详情'
            }
        }, {
            path: '/card/list',
            component: cardList,
            meta: {
                deep: 3,
                title: '卡列表'
            }
        }, {
            path: '/about',
            component: About,
            meta: {
                deep: 3
            }
        }, {
            path: '/userInfo',
            component: userInfo,
            meta: {
                deep: 3
            }
        }, {
            path: '/baoxian',
            component: () => import('./views/baoxian.vue'),
            meta: {
                deep: 2
            }
        }, {
            path: '/apply',
            component: () => import('./views/apply.vue'),
            meta: {
                deep: 6,
                title: '申请资料填写'
            }
        }, {
            path: '/login',
            component: () => import('./views/login.vue'),
            meta: {
                deep: 10,
                title: '登录'
            }
        }, {
            path: '/invitation',
            component: () => import('./views/Invitation.vue'),
            meta: {
                deep: 2,
                title: '邀请好友'
            }
        }, {
            path: '/doTask',
            component: () => import('./views/doTask.vue'),
            meta: {
                deep: 2,
                title: '您的梦想收入'
            }
        }, {
            path: '/loan',
            component: () => import('./views/loan.vue'),
            meta: {
                deep: 2,
                title: '贷款'
            }
        }, {
            path: '/autoinsurance',
            component: () => import('./views/autoinsurance.vue'),
            meta: {
                deep: 2,
                title: '车险'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    // 页面切换动画逻辑
    let transitionName = ''
    let toTag = Number(to.meta.deep)
    let fromTag = Number(from.meta.deep)
    if (toTag === 1) {
        transitionName = toTag < fromTag ? 'back' : ''
    } else {
        if (fromTag) {
            transitionName = toTag < fromTag ? 'back' : 'forward'
        } else {
            transitionName = ''
        }
    }
    if (to.path === '/login') {
        transitionName = 'bottomin'
    }
    if (from.path === '/login') {
        transitionName = 'bottomout'
    }
    store.commit('updateDirection', transitionName)
    next()
})

router.beforeEach((to, from, next) => {
    store.commit('toggleLoading', true)
    next()
})
router.afterEach((to, from) => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    store.commit('toggleLoading', false)
    store.commit('title', to.meta.title || '聚惠享')
    store.commit('setToolBarVisiable', to.meta.tool)
    store.commit('showReturn', !(to.meta.deep === 1 || to.meta.deep === 10))
})
export default router
